import state from "../store/store";
import findIndex from "lodash/findIndex";
import sumBy from "lodash/sumBy";
import get from "lodash/get";
import round from "lodash/round";
import { formatCost } from "../shared/helpers"

declare var UIkit;
// Set Basket Limit
const basketLimit = "10000";

const calculateBasket = (shop) => {
  // BasketTotal
  shop.BasketTotal = sumBy(shop.Basket, (item) => {
    return item.Quantity * item.Price;
  });

  // Add Discount
  if (shop.DiscountPerc && shop.DiscountPerc > 0) {
    shop.Discount = round(shop.BasketTotal * shop.DiscountPerc * -1.0, 2);
    shop.BasketTotal = shop.BasketTotal + shop.Discount;
  } else if (shop.Discount && shop.Discount > 0) {
    shop.BasketTotal = shop.BasketTotal + round(shop.Discount * -1.0, 2);
  }

  // Shipping
  // £10 + VAT for orders that parts total £50 + VAT and under
  // £15 + VAT for order that parts total £50 + VAT and above.
  // 20 + VAT for order that parts total 250 + VAT and above.
  if (shop.BasketTotal == 0) shop.Shipping = 0;
  else if (shop.BasketTotal > 250 / 1.2) shop.Shipping = 20;
  else if (shop.BasketTotal > 50 / 1.2) shop.Shipping = 15;
  else shop.Shipping = 10;
  shop.ShippingLabel = "DPD tracked (1-2 business days)";
  shop.BasketLimitExceeded = shop.BasketTotal > basketLimit;

  // VAT
  const VAT = get(state.website, "Shop.VAT") || 0.2;
  shop.VAT = round((shop.BasketTotal + shop.Shipping) * VAT, 2);

  // Total
  shop.Total = shop.BasketTotal + shop.Shipping + shop.VAT;

  // Cache
  const toStore = {
    Modified: new Date(),
    Basket: state.shop.Basket,
  };
  localStorage.setItem("howardson-basket", JSON.stringify(toStore));
  return shop;
};

const removeItem = (PartNumber: string) => {
  state.shop.Basket = state.shop.Basket.filter((item) => {
    return item.PartNumber != PartNumber;
  });
  state.shop = calculateBasket(state.shop);
  state.shop = { ...state.shop };
  return;
};

const upsertItem = (item: any) => {
  const basket = state.shop.Basket;
  item.Quantity = Math.abs(Math.floor(item.Quantity)) || 1;
  const i = findIndex(basket, ["PartNumber", item.PartNumber]);
  if (i > -1) {
    basket[i] = item;
  } else {
    basket.push(item);
    const options = {
      message: ` <div class='uk-background-primary-striped uk-light uk-padding-small'>
                            <div class="uk-heading-small uk-margin-remove-bottom">
                                Added to Basket
                            </div>
                            <div class="uk-margin">
                                <div class="uk-flex"><div class="uk-flex-1">${item.Title}</div><div>${formatCost(state.shop.Currency, item.Price)}</div></div>
                                <div class="uk-flex uk-text-meta"><div class="uk-flex-1">${item.PartNumber}</div><div>Qty: ${item.Quantity}</div></div>
                            </div>
                            <div>
                                <a class="uk-button uk-button-default uk-width-1-1" href="/checkout">Checkout</a>
                                <a class="uk-button uk-button-default uk-margin-small-top uk-width-1-1" href="/shop">Continue Shopping</a>
                            </div>
                        </div>`,
      pos: "bottom-right",
      timeout: 3000,
    };
    UIkit.notification(options);
  }
  state.shop = calculateBasket(state.shop);
  state.shop = { ...state.shop };
  return;
};

const updateQuantity = (PartNumber: string, Quantity: number, item?: any) => {
  const basket = state.shop.Basket;
  if (Quantity <= 0) return removeItem(PartNumber);
  const i = findIndex(basket, ["PartNumber", PartNumber]);
  if (i > -1) {
    basket[i].Quantity = Math.floor(Quantity);
  } else {
    if (item) {
      item.Quantity = Math.floor(Quantity);
      upsertItem(item);
      return;
    }
  }
  state.shop = calculateBasket(state.shop);
  state.shop = { ...state.shop };
  return;
};

const updateDiscount = (Amount: any, Percent: any, Code: string) => {
  state.shop.Discount = Amount;
  state.shop.DiscountCode = Code;
  state.shop.DiscountPerc = Percent;
  state.shop.DiscountDesc = `${Code} -${
    Percent ? Percent * 100 + "%" : Amount
  }`;

  state.shop = calculateBasket(state.shop);
  state.shop = { ...state.shop };
  return;
};

const getQuantity = (PartNumber: string) => {
  const basket = state.shop.Basket;
  const i = findIndex(basket, ["PartNumber", PartNumber]);
  if (i > -1) {
    return basket[i].Quantity;
  } else {
    return 1;
  }
};

const inBasket = (PartNumber: string) => {
  const basket = state.shop.Basket;
  const i = findIndex(basket, ["PartNumber", PartNumber]);
  if (i > -1) {
    return true;
  } else {
    return false;
  }
};

export {
  removeItem,
  upsertItem,
  updateQuantity,
  getQuantity,
  inBasket,
  calculateBasket,
  updateDiscount,
};
